import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import TableBody from "./components/tableBody";
import { useNavigate } from "react-router-dom";
import styles from "./styles/style.module.scss";
import Filters from "./components/filters";
import { functionService } from "../../lib/functions";
import TableHeader from "./components/tableHeader";

const TrainingList = () => {
  let navigate = useNavigate();
  const [trainingsList, setTrainingsList] = useState([]);
  const [trainingLoader, setTrainingLoader] = useState(true);

  const getTrainingList = async () => {
    setTrainingLoader(true);
    try {
      let { response } = await functionService.get(`training`);
      setTrainingsList(response?.data?.data?.allTrainings.map(currentTraining => { return { ...currentTraining, type: "Bootcamp" } }));
      setTrainingLoader(false);
      getSessionList(response?.data?.data?.allTrainings.map(currentTraining => { return { ...currentTraining, type: "Bootcamp" } }));
    } catch (error) {
      console.log({ error });
    }
  };

  const getSessionList = async (trainingsList) => {

    try {
      let { response } = await functionService.get(`rocketSeries`);
      setTrainingsList([...response?.data?.data.map(currentTraining => { return { ...currentTraining, type: "Rocket Series" } }), ...trainingsList]);

    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getTrainingList();
  }, []);

  const handleTrainingDelete = ({ trainingsList, deleteIndex }) => {
    setTrainingsList(
      trainingsList.filter((currentTraining, index) => index !== deleteIndex)
    );
  };

  const deleteTraining = async ({ id, index,type }) => {
    try {
      const { status } = type === "Bootcamp" ? await functionService.remove(`training/${id}`) : await functionService.remove(`rocketSeries/${id}`)
      if (status) {
        handleTrainingDelete({ trainingsList, deleteIndex: index })
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <div>
      <div className={styles.listHeading}>
        <h4>All Live Classes Trainings</h4>
        < div style={{
          display: "flex",
          alignItems: "center", justifyContent: "flex-end"
        }} >
          <Button
            variant="primary"
            onClick={() => {
              navigate("/training/addRocketSeries", { replace: true });
            }}
            style={{ marginRight: "20px" }}
          >
            + Add Rocket series
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              navigate("/training/add", { replace: true });
            }}
          >
            + Add New
          </Button>
        </div>
      </div>

      <Filters />
      <div className={styles.classesTable}>
        <div>
          <TableHeader />
          <TableBody trainingLoader={trainingLoader} deleteTraining={deleteTraining} trainingsList={trainingsList} />
        </div>
      </div>
    </div>
  );
};

export default TrainingList;
